// locale-unextracted-ignore-file
import { DownloadMediaNotificationCompletedView } from '@app/modules/logger/screens/stream/features/download-media/NotificationViews';
import { useState } from 'react';

export interface CustomScreenDownloadMediaTabCompletedToastProps {
  /** Dismisses the wrapping ribbon toast (e.g. after a simulated download). */
  onClose: () => void;
}

/**
 * Toast body for CompletedView demo: holds downloading state and dismisses the toast on download.
 */
export function CustomScreenDownloadMediaTabCompletedToast({
  onClose,
}: CustomScreenDownloadMediaTabCompletedToastProps) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => {
      onClose();
      setDownloading(false);
    }, 1500);
  };

  return (
    <DownloadMediaNotificationCompletedView
      onDownload={handleDownload}
      downloading={downloading}
      fileSizeBytes={10004000}
    />
  );
}
